import { styled } from "@mui/system";
import {
  DISPLAY_FLEX,
  DISPLAY_BLOCK,
  FLEX_DIRECTION_COLUMN,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  BORDER_PRIMARY,
  FLEX_DIRECTION_ROW,
  BORDER_SECONDARY,
  FLEX_ALIGN_START,
  FLEX_ALIGN_CENTER,
  MAX_WIDTH,
  FONT_SIZE_MD,
  FONT_WEIGHT_BOLD,
} from "../../../config/styles";
import { colors } from "../../../config/colors";

export const ProductDetailsStyled = styled("div")(({ theme }) => ({
  "& .welcome-page-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    padding: "36px 24px 24px 24px",
    marginLeft: "256px",
    backgroundColor: theme.palette.secondary.contrastText,
  },
  "& .configuration-page": {
    display: DISPLAY_BLOCK,
    backgroundColor: theme.palette.secondary.contrastText,
    margin: "0 128px 32px 296px",
    borderRadius: "8px",
    width: "calc(100% - 424px) !important",
    border: BORDER_PRIMARY,
    minWidth: "480px !important",
  },
  "& .configuration-general": {
    margin: "32px 24px 24px 24px",
  },
  "& .image-box": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    backgroundColor: theme.palette.secondary.contrastText,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    alignItems: FLEX_ALIGN_CENTER,
    border: BORDER_SECONDARY,
    padding: "12px 16px",
    height: "72px",
    width: "90%",
    margin: "0 24px 0 24px",
  },
  "& .upload-image-box": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    borderRadius: "8px",
    backgroundColor: theme.palette.secondary.contrastText,
    border: BORDER_SECONDARY,
    padding: "16px",
    alignItems: FLEX_ALIGN_START,
    height: "72px",
    width: "90%",
    gap: "8px",
    margin: "24px",
  },
  "& .button-primary": {
    width: MAX_WIDTH,
  },
  "& .specification-box": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    alignItems: FLEX_ALIGN_CENTER,
    border: BORDER_SECONDARY,
    padding: "24px",
  },
  "& .generate-button": {
    display: DISPLAY_FLEX,
    height: "40px",
    fontFamily: "Open Sans, sans-serif",
    fontSize: FONT_SIZE_MD,
    background: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    margin: "0 auto",
    fontWeight: FONT_WEIGHT_BOLD,
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    "&:disabled": {
      background: theme.palette.primary.main,
      opacity: 0.5,
      cursor: "not-allowed",
      border: "none",
    },
  },
  "& .cancel-button": {
    display: DISPLAY_FLEX,
    height: "40px",
    fontFamily: "Open Sans, sans-serif",
    fontSize: FONT_SIZE_MD,
    background: theme.palette.secondary.contrastText,
    border: BORDER_PRIMARY,
    padding: "8px 12px",
    justifyContent: FLEX_ALIGN_CENTER,
    alignItems: FLEX_ALIGN_CENTER,
    margin: "0 auto",
    fontWeight: FONT_WEIGHT_BOLD,
    borderRadius: "4px",
    color: colors.warning,
    "&:hover": {
      backgroundColor: colors.background,
      color: colors.warning,
      border: BORDER_PRIMARY,
    },
    "&:disabled": {
      background: colors.background,
      color: colors.warning,
      opacity: 0.5,
      cursor: "not-allowed",
      border: "none",
    },
  },
  "& .specification-wrapper": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    padding: "24px",
    width: "100%",
    borderTop: BORDER_SECONDARY,
  },
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  '& input[type="number"]': {
    "-moz-appearance": "textfield",
  },
   "& .receipent-list": {
    display: DISPLAY_FLEX,
    width: MAX_WIDTH,
    padding: "16px",
    border: BORDER_PRIMARY,
    borderRadius: "8px",
    borderStyle: "dashed",
    marginTop: "16px",
  },
}));
